import app from 'flarum/common/app';

app.initializers.add('indigo/flarum-ext-custom-field', () => {
  console.log('[indigo/flarum-ext-custom-field] Hello, forum and admin!');
});
